module.exports = __webpack_public_path__ + "static/wl_logo-mob2x-546a5d30e0b883582f4a69e1057d879e.png";